"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Eye = function Eye() {
  return _react2.default.createElement(
    "g",
    { id: "eye" },
    _react2.default.createElement("path", { d: "M250,80 C136.4,80 39.3,150.7 0,250.5 C39.3,350.3 136.4,421 250,421 C363.6,421 460.7,350.3 500,250.5 C460.7,150.7 363.6,80 250,80 Z M250,364.1 C187.3,364.1 136.4,313.2 136.4,250.5 C136.4,187.8 187.3,136.8 250,136.8 C312.7,136.8 363.6,187.7 363.6,250.4 C363.6,313.1 312.7,364.1 250,364.1 Z M250,182.3 C212.3,182.3 181.8,212.8 181.8,250.5 C181.8,288.2 212.3,318.7 250,318.7 C287.7,318.7 318.2,288.2 318.2,250.5 C318.2,212.8 287.7,182.3 250,182.3 Z", id: "Shape" })
  );
};

exports.default = Eye;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Eye.js
// module id = 2947
// module chunks = 4